/*******************************************************************************
 * Licensed Materials - Property of IBM
 * IBM Cloud Code Engine, 5900-AB0
 * © Copyright IBM Corp. 2020, 2022
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 ******************************************************************************/
import React from 'react';
// Ace editor
import ace from 'ace-builds/src-noconflict/ace';

import appUtils from '../utils/app';

// Ace editor modes (languages)
import 'ace-builds/src-min-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-golang';
import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-python';
// Ace editor theme
import 'ace-builds/src-noconflict/theme-chrome';
import 'ace-builds/src-noconflict/theme-monokai';

// do not use inline styles to comply with CSP rules
ace.config.set('useStrictCSP', true);
// we also do not want use web workers for syntax highlighting at the moment
ace.config.set('useWorker', false);

const app = (): void => {
  import('./components/Serverless/Serverless.tsx').then((module) => {
    appUtils.init(<module.Serverless />);
  });
};

window.armada.init = app;
export default app;
